import { useEffect, useState } from 'react';
import { BellRing, Loader2 } from 'lucide-react';
import { api, ErrorApi } from '../api';
import Ayuda from '../ui/Ayuda';
import EstadoVacio from '../ui/EstadoVacio';

/* =====================================================================
   Avisos automáticos · DIRECTRIZ-TICKETS F4 (TEGO avisa solo)
   =====================================================================
   TEGO abre tickets solo cuando un vigía detecta algo: un aparato que
   deja de reportar, un respaldo que falla, el disco casi lleno, la cola
   de correo atorada. Cada fuente es un interruptor que la empresa
   enciende o apaga. Es de quien administra la mesa.
   ===================================================================== */

export default function FuentesAutomaticas() {
  const [lista, setLista] = useState(null);
  const [error, setError] = useState('');
  const [ocupada, setOcupada] = useState('');

  function recargar() {
    api.get('/tickets/fuentes-automaticas')
      .then((l) => { setLista(l); setError(''); })
      .catch((e) => setError(e instanceof ErrorApi ? e.message
        : 'No se pudieron cargar los avisos automáticos. Vuelve a intentarlo.'));
  }
  useEffect(recargar, []);

  async function alternar(f) {
    if (ocupada) return;
    setOcupada(f.clave);
    try {
      await api.post(`/tickets/fuentes-automaticas/${f.clave}`, { activo: !f.activo });
      setLista((prev) => prev.map((x) => (
        x.clave === f.clave ? { ...x, activo: !x.activo } : x)));
      setError('');
    } catch (e) {
      setError(e instanceof ErrorApi ? e.message : 'No se pudo cambiar el aviso.');
    } finally { setOcupada(''); }
  }

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4 p-4">
      <header>
        <h1 className="flex items-center gap-2 text-xl font-semibold text-gray-900">
          <BellRing className="h-6 w-6" aria-hidden="true" /> Avisos automáticos
        </h1>
        <p className="text-gray-600">Qué revisa TEGO por su cuenta para abrir un ticket sin que nadie lo reporte.</p>
        <Ayuda id="fuentes_auto.pantalla" />
      </header>

      {error && <p role="alert" className="rounded-lg bg-red-50 p-3 text-sm text-red-800">{error}</p>}

      {lista === null && !error && (
        <p className="flex items-center gap-2 py-8 text-sm text-gray-500">
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Cargando avisos automáticos…
        </p>
      )}

      {lista !== null && lista.length === 0 && (
        <EstadoVacio
          icono={BellRing}
          titulo="Aún no hay avisos automáticos configurados"
          descripcion="Cuando esta empresa use el módulo, aquí aparecerán las señales que TEGO puede vigilar por su cuenta."
        />
      )}

      {lista !== null && lista.length > 0 && (
        <div className="flex flex-col gap-2 rounded-xl border border-gray-200 p-3">
          <Ayuda id="fuentes_auto.encender" />
          <ul className="flex flex-col gap-2">
            {lista.map((f) => (
              <li key={f.clave}
                  className="flex items-center justify-between gap-3 rounded-xl border border-gray-200 p-3">
                <span className="min-w-0">
                  <span className="block truncate font-medium text-gray-900">{f.nombre}</span>
                  <span className="block text-xs text-gray-500">{f.descripcion}</span>
                  {f.abiertos > 0 && (
                    <span className="mt-1 inline-block rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
                      {f.abiertos} abierto{f.abiertos === 1 ? '' : 's'} ahora
                    </span>
                  )}
                </span>
                <button
                  type="button"
                  onClick={() => alternar(f)}
                  disabled={ocupada === f.clave}
                  aria-pressed={f.activo}
                  className={`flex min-h-[44px] min-w-[7rem] items-center justify-center gap-2 rounded-xl px-3 text-sm font-semibold disabled:opacity-50 ${
                    f.activo
                      ? 'bg-green-100 text-green-800'
                      : 'border border-gray-300 text-gray-600'
                  }`}
                >
                  {ocupada === f.clave && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
                  {f.activo ? 'Encendido' : 'Apagado'}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
